"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhone = void 0;
const react_phone_number_input_1 = require("react-phone-number-input");
function validatePhone(phone) {
    return (0, react_phone_number_input_1.isPossiblePhoneNumber)(phone);
}
exports.validatePhone = validatePhone;
//# sourceMappingURL=validatePhone.js.map